import { StateStatus } from '../../../../shared/infrastructure/store/utils/state_status';
import { BankAccountType as actions } from '../actions/action';
import { BankAccountAction } from '../actions/action.creators';
import BankAccountState from '../state/state';

const BankAccounts = (state = new BankAccountState({}), action: BankAccountAction) => {
    switch (action.type) {
        case actions.GETTING_SETTLEMENT_ACCOUNT: {
            return state.copyWith({ status: StateStatus.loading });
        }
        case actions.GETTING_SETTLEMENT_ACCOUNT_SUCCESS: {
            return state.copyWith({
                status: StateStatus.success,
                bankAccounts: action.payload
            });
        }
        case actions.GETTING_SETTLEMENT_ACCOUNT_FAILURE: {
            return state.copyWith({
                status: StateStatus.failure,
                bankAccounts: [],
                error: action.payload
            });
        }
        default:
            return state;
    }
};

export default BankAccounts;
